import angular from 'angular';
import grid from 'angular-ui-grid';

import storageFilters from '../../components/filters/storage';

export class ProductMovementsController {

  closeWindow: Function;

  data;
  options;
  grid;

  /*@ngInject*/
  constructor($scope, Storage, WindowService) {
    this.Storage = Storage;
    this.scope   = $scope;

    this.closeWindow = WindowService.delItem;
  }

  $onInit() {

    return this.Storage.loadMovements({productId: this.data.product._id})
      .then((movements) => {
        this.options = {
          primaryKey: '_id',
          enableCellEdit: true,
          enableRowSelection: true,
          enableRowHeaderSelection: false,
          multiSelect: false,
          modifierKeysToMultiSelect: false,
          noUnselect: true,
          rowEditWaitInterval: -1,
          data: movements,
          onRegisterApi: (gridApi) => {
            this.grid = gridApi;
          },
          columnDefs: [{
            displayName: '#',
            field: '_id',
            groupable: false,
            resizable: false,
            sortable: false,
            visible: false,
            width: 50
          }, {
            displayName: 'Дата/Время',
            field: 'dtime',
            groupable: false,
            resizable: true,
            sortable: true,
            visible: true,
            width: 150,
            cellFilter: "date:'dd.MM.yy HH:mm'",
            sort: {
              direction: 'desc',
              priority: 100 
            }
          }, {
            displayName: 'Пользователь',
            field: 'userId',
            groupable: true,
            resizable: true,
            sortable: true,
            visible: true,
            width: 150,
            cellFilter: 'renderUser',
          }, {
            displayName: 'Кол-во',
            field: 'count',
            groupable: true,
            resizable: true,
            sortable: true,
            visible: true,
            width: 100,
          }, {
            displayName: 'Комментарий',
            field: 'comment',
            groupable: false,
            resizable: false,
            sortable: false,
            visible: true,
          }]
        };
      });
  }

  close() {
    this.closeWindow(this.data.id);
  }
}

export default angular.module('storageApp.product.movments', [
    grid,
    grid + '.selection',
    grid + '.edit',
    grid + '.rowEdit',
    grid + '.saveState',
    grid + '.grouping',

    storageFilters
  ])
  .filter('renderUser', function(Storage){
    'ngInject';

    return function (input) {
      return Storage.getUsers()
        .filter(user => {
          return input == user._id;
        })
        .map(user => {
          return user.name;
        })
        .shift();
    };
  })
  .component('productMovements', {
    bindings: {data: '='},
    transclude: true,
    template: require('./product-movements.html'),
    controller: ProductMovementsController
  })
  .name;



// WEBPACK FOOTER //
// ./client/app/product-movements/product-movements.component.js